import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AdminService } from '../../Services/admin.service';
import { LoaderService } from 'src/app/Services/loader.service';

@Injectable()
export class ActiveFAQResolver implements Resolve<any> {

  constructor(private adminservice: AdminService,
    private loaderService: LoaderService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    this.loaderService.showLoader();

    return this.adminservice.GetActiveFAQS().pipe(
      map( (dataFromApi) =>  dataFromApi ),
        catchError( (err) =>Observable.throw(err))
    )
  }
}